import Axios from 'axios';
import { Config } from '../apiRoutes';
import { authHeaders } from '../headers';

import {
  SETTINGS_REQUESTED,
  SETTINGS_SUCCESS,
  SETTINGS_FAILURE,
  SETTINGS_UPDATE_REQUESTED,
  SETTINGS_UPDATE_SUCCESS,
  SETTINGS_UPDATE_FAILURE,
} from '../types';

export const settingsRequested = () => {
  return {
    type: SETTINGS_REQUESTED
  }
};

export const settingsSuccess = (settings) => {
  return {
    type: SETTINGS_SUCCESS,
    settings: settings
  }
};

export const settingsFailure = () => {
  return {
    type: SETTINGS_FAILURE
  }
};

export const settingsUpdateRequested = () => {
  return {
    type: SETTINGS_UPDATE_REQUESTED
  }
};

export const settingsUpdateSuccess = (settings) => {
  return {
    type: SETTINGS_UPDATE_SUCCESS,
    settings: settings
  }
};

export const settingsUpdateFailure = () => {
  return {
    type: SETTINGS_UPDATE_FAILURE
  }
};

export const getSettings = () => {
  return async (dispatch) => {
    dispatch(settingsRequested());

    const endPoint = Config.baseUrl + Config.settings;
    const headers = await authHeaders();

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(settingsSuccess(response.data));
      })
  }
}


export const updateSettings = (settings) => {
  return async (dispatch) => {
    dispatch(settingsUpdateRequested());

    const endPoint = Config.baseUrl + Config.settings;
    const headers = await authHeaders();

    return Axios.post(endPoint, { 'settings': settings } , { headers: headers })
      .then((response) => {
        dispatch(settingsUpdateSuccess(response.data));
      })
  }
}
